import { SafeLink } from '@/components/ui/SafeLink';
import type { CategoryItem } from '@/constants/product/category';
import { Box, Button, Grid, GridItem, Stack, Text } from '@chakra-ui/react';
import NextImage from 'next/image';

type CategorySectionProps = {
  onClose: () => void;
  items: CategoryItem[];
};

const CategorySection = ({ onClose, items }: CategorySectionProps) => {
  return (
    <>
      <Grid templateColumns="repeat(3, 1fr)" gap={4}>
        {items.map((item) => (
          <GridItem key={item.name} textAlign="center">
            <SafeLink href={item.url} onClick={onClose}>
              <Stack gap="20px" direction="column" align="center">
                <Box
                  borderRadius="60px"
                  overflow="hidden"
                  width="60px"
                  height="60px"
                  border="1px solid"
                  borderColor="neutral.10"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <NextImage src={item.imageUrl} alt={item.imageAlt} width={60} height={60} objectFit="contain" />
                </Box>
                <Text textStyle="caption1" fontWeight="medium" color="neutral.50" textAlign="center">
                  {item.name}
                </Text>
              </Stack>
            </SafeLink>
          </GridItem>
        ))}
      </Grid>
      <Box textAlign="center" mt={6} mb={4}>
        <Box as="span" width="100%" maxWidth="300px" display="inline-block">
          <SafeLink href="/shop">
            <Button
              variant="outline"
              width="100%"
              borderColor="brand.50"
              color="brand.50"
              borderRadius="4px"
              onClick={onClose}
            >
              Shop All
            </Button>
          </SafeLink>
        </Box>
      </Box>
    </>
  );
};

export default CategorySection;
